<template>
    <div class="sm:col-span-12">
        <div>
            <div class="mt-3 w-40">
                <FormLabel :value="$t('messages.tolerance')" for="tolerance" />
                <FormInput
                    id="tolerance"
                    v-model.trim="form.tolerance"
                    name="tolerance"
                    @keypress.enter.prevent
                    :placeholder="$t('messages.tolerance')"
                    type="number"
                    required
                    min="0"
                    step="any"
                    class="mt-3 w-40"
                />
                <FormError :value="errors[`options.tolerance`]" class="mt-2" />
            </div>
        </div>

        <div class="flex flex-col gap-2 mt-5">
            <div class="md:grid md:grid-cols-12 md:gap-6">
                <div class="col-span-6">
                    <FormLabel :value="`${$t('messages.number')} 1`" for="value_0" />
                    <FormInput
                        id="value_0"
                        v-model.trim="form.value_0"
                        name="value_0"
                        @keypress.enter.prevent
                        :placeholder="`${$t('messages.number')} 1`"
                        type="number"
                        required
                        step="any"
                        class="mt-1 w-full"
                    />
                    <FormError :value="errors[`options.value_0`]" class="mt-2" />
                </div>
                <div class="col-span-6">
                    <FormLabel :value="`${$t('messages.label')} 1`" for="label_0" />
                    <FormInput
                        id="label_0"
                        v-model.trim="form.label_0"
                        name="label_0"
                        @keypress.enter.prevent
                        :placeholder="`${$t('messages.label')} 1`"
                        type="text"
                        required
                        maxlength="30"
                        class="mt-1 w-full"
                    />
                    <FormError :value="errors[`options.label_0`]" class="mt-2" />
                </div>
            </div>
            <!-- optionals below -->
            <br />
            <div class="md:grid md:grid-cols-12 md:gap-6">
                <div class="col-span-6">
                    <FormLabel :value="`${$t('messages.number')} 2`" for="value_1" />
                    <FormInput
                        id="value_1"
                        v-model.trim="form.value_1"
                        name="value_1"
                        @keypress.enter.prevent
                        :placeholder="
                            form.label_1 || form.value_1 ? `${$t('messages.number')} 2` : $t('messages.(optional)')
                        "
                        type="number"
                        :required="!!form.label_1"
                        step="any"
                        class="mt-1 w-full"
                    />
                    <FormError :value="errors[`options.value_1`]" class="mt-2" />
                </div>
                <div class="col-span-6">
                    <FormLabel :value="`${$t('messages.label')} 2`" for="label_1" />
                    <FormInput
                        id="label_1"
                        v-model.trim="form.label_1"
                        name="label_1"
                        @keypress.enter.prevent
                        :placeholder="
                            form.label_1 || form.value_1 ? `${$t('messages.label')} 2` : $t('messages.(optional)')
                        "
                        type="text"
                        :required="!!form.value_1"
                        maxlength="30"
                        class="mt-1 w-full"
                    />
                    <FormError :value="errors[`options.label_1`]" class="mt-2" />
                </div>
            </div>
            <br />
            <div class="md:grid md:grid-cols-12 md:gap-6">
                <div class="col-span-6">
                    <FormLabel :value="`${$t('messages.number')} 3`" for="value_2" />
                    <FormInput
                        id="value_2"
                        v-model.trim="form.value_2"
                        name="value_2"
                        @keypress.enter.prevent
                        :placeholder="
                            form.label_2 || form.value_2 ? `${$t('messages.number')} 3` : $t('messages.(optional)')
                        "
                        type="number"
                        :required="!!form.label_2"
                        step="any"
                        class="mt-1 w-full"
                    />
                    <FormError :value="errors[`options.value_2`]" class="mt-2" />
                </div>
                <div class="col-span-6">
                    <FormLabel :value="`${$t('messages.label')} 3`" for="label_2" />
                    <FormInput
                        id="label_2"
                        v-model.trim="form.label_2"
                        name="label_2"
                        @keypress.enter.prevent
                        :placeholder="
                            form.label_2 || form.value_2 ? `${$t('messages.label')} 3` : $t('messages.(optional)')
                        "
                        type="text"
                        :required="!!form.value_2"
                        maxlength="30"
                        class="mt-1 w-full"
                    />
                    <FormError :value="errors[`options.label_2`]" class="mt-2" />
                </div>
            </div>
            <br />
        </div>
    </div>
</template>

<script>
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormError from '@/components/Forms/FormError.vue';

export default {
    name: 'QuestionMathMultipleMagnitudesOptions',
    components: {
        FormLabel,
        FormInput,
        FormError,
    },
    props: {
        modelValue: {
            required: true,
        },
        errors: {
            required: true,
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            form: this.modelValue,
        };
    },
    watch: {
        form(newVal) {
            this.$emit('update:modelValue', newVal);
        },
    },
    mounted() {
        let defaultOptions = {
            tolerance: 0,
            label_0: '',
            value_0: '',
            label_1: '',
            value_1: '',
            label_2: '',
            value_2: '',
        };
        if (!this.form.hasOwnProperty('tolerance')) {
            Object.entries(defaultOptions).forEach((entry) => (this.form[entry[0]] = entry[1]));
        }
    },
};
</script>
